import { css as n, styled as f } from "styled-components";
import { B as c, a, f as i } from "./style-8UHgYe1v.js";
import { m, a as p, f as $ } from "./index-QRkynDgW.js";
const h = {
  6: 3,
  8: 2
}, o = 12, r = {
  xs: "4px",
  sm: "12px",
  md: "16px",
  lg: "24px",
  xl: "24px",
  xxl: "32px"
}, l = (t, s) => {
  switch (t) {
    case !0:
      return n`
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
      `;
    case "auto":
      return n`
        flex: 0 0 auto;
        width: auto;
        max-width: none;
      `;
    default: {
      const x = `calc(${100 / o * t}% - (${s} * (${o} - ${t}) / ${o}))`;
      return n`
        flex: 0 0 ${x};
        max-width: ${x};
      `;
    }
  }
}, u = (t, s) => {
  const e = `calc((${t} / ${o}) * 100% + (${s} * ${t} / ${o}))`;
  return n`
    margin-left: ${e};
  `;
}, y = f.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 1px;
  ${m}

  ${({ $col: t }) => {
  if (t)
    return Object.keys(c).map((s) => {
      if (typeof t != "object")
        return a(s, l(t, r[s]));
      const e = t[i(t, s)];
      if (e)
        return a(s, l(e, r[s]));
    });
}}

  ${({ $offset: t }) => {
  if (t)
    return Object.keys(c).map((s) => {
      if (typeof t != "object")
        return a(s, u(t, r[s]));
      const e = t[i(t, s)];
      if (e)
        return a(s, u(e, r[s]));
    });
}}
`, j = f.div.attrs({ $flexWrap: "wrap" })`
  ${p}
  ${$}
  ${m}

  ${Object.keys(r).map(
  (t) => a(
    t,
    n`
        gap: 0 ${r[t]};
      `
  )
)}
`;
export {
  y as C,
  j as R,
  l as a,
  u as c,
  h as o
};
